import React from "react";

export default function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/TeresaCodes/weather-app-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>{" "}
      by <em>Teresa</em>
    </footer>
  );
}
